/*
@uses: https://www.algolia.com/doc/api-reference/widgets/menu-select/js/
 */

// This template for the items inside of the Algolia list item
export const menuSelectItem = '<span class="hover:underline">{{label}}</span>'

// classes for the wrapping li that's added by Algolia
// Note: additional styles, for functions such as active state, are in sass/_components.algolia.scss
export const libraryMenuSelectClasses = {
  root: 'MyCustomMenuSelectList',
  noRefinementRoot: 's-no-results',
  select: ['input-select--minimal w-full'],
  option: ['flex w-full'],
}
